export default __webpack_public_path__ + "static/media/Colimotl.d1039b97.png";